import { Outlet } from '@tanstack/react-router';
import styled from '@emotion/styled';

const Container = styled.div({
  maxWidth: '800px',
  padding: '0 20px',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
});

const Root = styled.div({
  fontFamily: `"Jost", serif`,
  display: 'flex',
  flex: 1,
  height: '100%',
  overflow: 'scroll',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
});

const Footer = styled.div({
  color: '#999',
  paddingTop: 32,
  paddingBottom: 64,
  borderTop: `1px solid #ddd`,
  marginTop: 16,
  textAlign: 'center',
});

export default function RootLayout() {
  return (
    <Root>
      <Container>
        <Outlet />
      </Container>
      <Footer>
        <div>© 2025 Principal Ideal Ltd</div>
        <div>
          <a href='/terms'>Terms of service</a>
          <a href='/privacy'>Privacy policy</a>
        </div>
      </Footer>
    </Root>
  );
}
